<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Xem chi tiết nhật ký sao lưu dữ liệu</strong>
                    </div>
                    <b-form @submit.prevent="save">
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Người thực hiện: "
                                              label-for="input-code"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ backupLog.userName }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Đơn vị: "
                                              label-for="input-code"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ backupLog.unitName }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Thao tác: "
                                              label-for="input-code"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ backupLog.action == 1 ? 'Sao lưu' : 'Phục hồi' }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Đối tượng: "
                                              label-for="input-code"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ backupLog.backupType == 1 ? 'Dữ liệu đơn vị' : 'Dữ liệu toàn hệ thống' }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Thời gian: "
                                              label-for="input-code"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ backupLog.backupDate | formatTime }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Dung lượng: "
                                              label-for="input-code"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ convertToMB(backupLog.backupSize) }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Trạng thái: "
                                              label-for="input-code"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label :class="'col-form-label ' + (backupLog.status? 'text-success' : 'text-danger')">{{ $store.getters.getStatusName(backupLog.status ? 1 : 0) }}</label>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Thông tin lỗi: "
                                              label-for="input-code"
                                              :label-cols="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ backupLog.errorMessage }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-center">
                                <b-button type="button" variant="secondary" :to="{ path: '.' }">Quay lại</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    export default {
        name: 'BackupLogDetail',
        data() {
            return {
                backupLog: {},
            }
        },
        computed: {
            backupLogId() {
                return this.$route.params.backupLogId;
            },
        },
        created() {
            this.loadBackupLogDetail();
        },
        methods: {
            loadBackupLogDetail() {
                var vm = this;
                return this.$services.get(`logging/backup-logs/${this.backupLogId}`).done(backupLog => {
                    vm.backupLog = backupLog;
                });
            },
            convertToMB(byte) {
                if (byte) {
                    return (Math.ceil((byte / 1024 / 1024) * 100) / 100).toFixed(2) + ' MB';
                } else {
                    return '';
                }
            }
        }
    }
</script>
<style scoped>
</style>
